import React, { useState, useEffect, useRef } from 'react';
import { PendingInvoices} from '../../store/slices/reports';
import Loader from '../../common/Loader';
import { useDispatch } from 'react-redux';
import Table from '../../common/Table';
import AdminLayout from '../AdminLayout';
import { FaFileExcel } from "react-icons/fa";
import {DebtorsAgeingDownload } from "../../common/ExcelDownload"
import {toast } from 'react-hot-toast';

const InvoiceList = () => {
  const dispatch = useDispatch();
  const tableRef = useRef(null);

  const user = JSON.parse(localStorage.getItem('user'));
  const id = user?.data?.profile_id;

  const [isLoading, setIsLoading] = useState(false);
  const [invoicelist, setInvoicelist] = useState([]);
  const [selectedParty, setSelectedParty] = useState(null); // For ledger_id
  const [selectedRows, setSelectedRows] = useState([]);  // Stores selected row IDs
  const [selectAll, setSelectAll] = useState(false);
  const [columns, setColumns] = useState([
    { header: 'Checkbox', field: 'Checkbox' },
    { header: 'Invoice #', field: 'invoice_combined' },
    { header: 'Date', field: 'invoice_date' },
    { header: 'Party', field: 'party_name' },
    { header: 'Pending Amount', field: 'pending_amount' },
    { header: 'Invoice Amount', field: 'grand_total' },
  ]);

  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [totalPendingAmount, setTotalPendingAmount] = useState(0);
  const [totalPaidAmount, setTotalPaidAmount] = useState(0);



  const fetchInvoices = async () => {
    setIsLoading(true);
    // console.log('Selected Party:', selectedParty);
  
    const params = {
      profile_id: id,
      days_pending: selectedParty ? selectedParty : '',
    };
  
    try {
      const data = await dispatch(PendingInvoices(params)).unwrap();
      
      // Extract invoices list
      const invoices = data?.data || [];
  
      // Calculate total pending amount
      const pendingAmount = invoices.reduce((sum, invoice) => sum + (invoice.pending_amount || 0), 0);

      const paidAmount = invoices.reduce((sum, invoice) => sum + (parseFloat(invoice.grand_total) || 0), 0);
   
      // Update state
      setInvoicelist(invoices);
      setTotalPendingAmount(pendingAmount);
      setTotalPaidAmount(paidAmount)
    } catch (error) {
      setIsLoading(false);
      setInvoicelist([]);
      setTotalPendingAmount(0);
      setTotalPaidAmount(0)
      console.log('Error fetching invoices:', error.message);
    } finally {
      setIsLoading(false);
    }
  };
  

  useEffect(() => {
    fetchInvoices();
  }, [dispatch]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value.trim()); // Trim input to avoid trailing spaces
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    fetchInvoices();
  };

  const filteredItemList = invoicelist?.filter((party) => {
    const query = searchQuery.toLowerCase();
  
    return (
      party?.invoice_number?.toLowerCase().includes(query) ||
      party?.invoice_date?.toLowerCase().includes(query) ||
      party?.party_name?.toLowerCase().includes(query) ||
      (party?.pending_amount !== undefined &&
        party.pending_amount.toString().toLowerCase().includes(query)) ||
      (party?.grand_total !== undefined &&
        party.grand_total.toString().toLowerCase().includes(query))
    );
  });


  const handleExcelDownload = () => {
    const selectedInvoices = selectAll ? invoicelist.map(invoice => invoice.id) : selectedRows;

    if (!selectedInvoices || selectedInvoices.length === 0) {
        alert("Please select at least one invoice.");
        return;
    }

    const selectedData = invoicelist.filter(invoice => selectedInvoices.includes(invoice.id));

    if (selectedData.length === 0) {
        alert("No matching invoices found.");
        return;
    }

    try {
      DebtorsAgeingDownload(selectedData, "DebtorsAgeing.xlsx");
        toast.success("Downloading Excel file successfully!");
    } catch (error) {
        console.error("Error downloading Excel file:", error);
        alert("Failed to download the Excel file. Please try again.");
    }
};

const formatAmount = (value) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

  return (
    <AdminLayout>
      {isLoading && <Loader />}
      <div className="row content-body">
        <div className="container-fluid">
          <div className="page-header">
            <div>
              <h2 className="main-content-title tx-24 mg-b-5">Pending Invoices</h2>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#">Reports</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                Debtors Ageing
                </li>
              </ol>
            </div>
           <div className="d-flex justify-content-end">
              <button className="btn ripple btn-default"   onClick={handleExcelDownload} >
              Export Excel <FaFileExcel/>
              </button>
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-md-12">
              <div class="card custom-card">
                <div class="card-body">
                  <form onSubmit={handleFilterSubmit} className="row mb-4">
                    <div className="col-md-3">
                      <label>Pending Days</label>
                      {/* <Select options={partyOptions} placeholder="--Pending Days--" value={selectedParty} onChange={setSelectedParty} /> */}
                      <input name="display_name" type="text" class="form-control" onChange={(e)=>setSelectedParty(e.target.value)} value={selectedParty}/>
                    </div>
                    <div className="col-md-3 mt-2">
                      <button type="submit" className="btn btn-default mt-4">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <Table
                columns={columns}
                data={filteredItemList}
                tableRef={tableRef}
                pageSize={pageSize}
                setPageSize={setPageSize}
                currentPage={currentPage}
                totalCount={filteredItemList?.length}
                onPageChange={handlePageChange}
                handleSearchChange={handleSearchChange}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows} 
                selectAll={selectAll} 
                 setSelectAll={setSelectAll}
                 totalPendingAmount={formatAmount(totalPendingAmount)}
                 totalPaidAmount={formatAmount(totalPaidAmount)}
              />
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default InvoiceList;
